export default ( fields, data ) => {
   const errors = {};

   fields.forEach(({ name, fn, message }) => {
      const is_valid = fn
         ? fn( data )
         : !!data[ name ];

      if ( !is_valid )
         errors[ name ] = message || "To pole jest wymagane!";
   })

   return { is_valid: Object.keys( errors ).length === 0, errors }
}
